import React, { useEffect, useState } from "react";
import { endpoints } from "../lib/api";
import { ArrowRight, Sparkles } from "lucide-react";
import { useCurrency } from "../lib/currency";

function AdCard({ ad }) {
  return (
    <a
      href={ad.href || "#"}
      target={ad.href?.startsWith("http") ? "_blank" : undefined}
      rel="noopener noreferrer"
      data-testid={`ad-${ad.slot}-${ad.position}`}
      className="group block overflow-hidden rounded-2xl border border-zinc-100 bg-gradient-to-b from-zinc-50 to-white p-5 transition-all hover:-translate-y-0.5 hover:border-indigo-200 hover:shadow-md"
    >
      <div className="mb-3 flex items-center gap-1.5">
        <span className="rounded-md bg-zinc-200/60 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-zinc-500">
          {ad.kind === "newsletter" ? "Newsletter" : "Sponsored"}
        </span>
      </div>
      <h4 className="font-display text-base font-semibold leading-tight text-zinc-900">{ad.title}</h4>
      <p className="mt-1.5 text-sm leading-relaxed text-zinc-500">{ad.subtitle}</p>
      <div className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-indigo-600 group-hover:gap-1.5 transition-all">
        {ad.cta} <ArrowRight className="h-3.5 w-3.5" />
      </div>
    </a>
  );
}

export default function SidebarAds({ slot }) {
  const [ads, setAds] = useState([]);
  const { formatPrice } = useCurrency();

  useEffect(() => {
    endpoints.ads(slot).then((r) => setAds(r.data.items || [])).catch(() => setAds([]));
  }, [slot]);

  return (
    <aside
      data-testid={`sidebar-${slot}`}
      className="sticky top-24 flex h-fit w-full flex-col gap-4"
    >
      <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-zinc-400">
        {slot === "left" ? "Sponsored Tools" : "Premium Promotions"}
      </div>
      {ads.map((ad) => (
        <AdCard key={ad.id || `${ad.slot}-${ad.position}`} ad={ad} />
      ))}
      {slot === "right" && (
        <div className="rounded-2xl border border-indigo-100 bg-indigo-50/60 p-5">
          <div className="mb-2 flex items-center gap-1.5">
            <Sparkles className="h-3.5 w-3.5 text-indigo-600" />
            <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-indigo-700">Tip</span>
          </div>
          <p className="text-sm leading-relaxed text-indigo-900">
            Cloudflare sells .com domains at-cost (~{formatPrice(9.59)}) — no upsell, no markup.
          </p>
        </div>
      )}
    </aside>
  );
}
